/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioRepresentation
 */
export interface PortfolioRepresentation {
    /**
     * 
     * @type {string}
     * @memberof PortfolioRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioRepresentation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioRepresentation
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioRepresentation
     */
    created: number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioRepresentation
     */
    updated: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioRepresentation
     */
    companyKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioRepresentation
     */
    userKey?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioRepresentation
     */
    order: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioRepresentation
     */
    generatorKeys?: Array<string>;
}

/**
 * Check if a given object implements the PortfolioRepresentation interface.
 */
export function instanceOfPortfolioRepresentation(value: object): value is PortfolioRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    return true;
}

export function PortfolioRepresentationFromJSON(json: any): PortfolioRepresentation {
    return PortfolioRepresentationFromJSONTyped(json, false);
}

export function PortfolioRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'created': json['created'],
        'updated': json['updated'],
        'companyKey': json['companyKey'] == null ? undefined : json['companyKey'],
        'userKey': json['userKey'] == null ? undefined : json['userKey'],
        'order': json['order'],
        'generatorKeys': json['generatorKeys'] == null ? undefined : json['generatorKeys'],
    };
}

export function PortfolioRepresentationToJSON(json: any): PortfolioRepresentation {
    return PortfolioRepresentationToJSONTyped(json, false);
}

export function PortfolioRepresentationToJSONTyped(value?: PortfolioRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'created': value['created'],
        'updated': value['updated'],
        'companyKey': value['companyKey'],
        'userKey': value['userKey'],
        'order': value['order'],
        'generatorKeys': value['generatorKeys'],
    };
}

